import { render } from "./FormTextField.vue?vue&type=template&id=22a82a2b&scoped=true"
import script from "./FormTextField.vue?vue&type=script&lang=js"
export * from "./FormTextField.vue?vue&type=script&lang=js"

import "./FormTextField.vue?vue&type=style&index=0&id=22a82a2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22a82a2b"

export default script